module.exports = __webpack_public_path__ + "static/media/mordekaiser.d04a91a5.png";